import {
  Linking,
  StyleSheet,
  Text,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
  ViewStyle,
} from "react-native";
import { Colors, Spacing, Typography } from "../../styles";
import { EvilIcons, FontAwesome5, FontAwesome } from "@expo/vector-icons";
import { useState } from "react";
import { Data } from "../../types";
import { entityIcon } from "../../utils/data";

export interface TaskProps {
  entity?: Data.Entity;
  text: string;
  style?: ViewStyle;
}
const Task = ({ entity, text, style }: TaskProps) => {
  const [checked, setChecked] = useState(false);

  return (
    <TouchableWithoutFeedback onPress={() => setChecked(!checked)}>
      <View
        style={[styles.container, checked && styles.checkedContainer, style]}
      >
        <View style={[styles.centeredRow, styles.left]}>
          {/* Checkbox */}
          <View style={[styles.checkbox, checked && styles.checkedCheckbox]}>
            {checked && (
              <FontAwesome name="check" size={10} color={Colors.black} />
            )}
          </View>
          {/* Text */}
          <View style={styles.text}>
            {/* entity */}
            {entity && (
              <View style={[styles.centeredRow, styles.entity]}>
                <FontAwesome5
                  name={entityIcon(entity)}
                  size={14}
                  color={Colors.white}
                  style={styles.icon}
                />
                <Text style={[Typography.paragraph, styles.title]}>
                  {entity}
                </Text>
              </View>
            )}
            {/* Subtitle */}
            <Text style={Typography.paragraph}>{text}</Text>
          </View>
        </View>

        {/* External link */}
        <TouchableOpacity
          onPress={async () => {
            const url = "https://google.com";
            const supported = await Linking.canOpenURL(url);
            if (supported) Linking.openURL(url);
          }}
        >
          <EvilIcons name="external-link" size={24} color={Colors.plum400} />
        </TouchableOpacity>
      </View>
    </TouchableWithoutFeedback>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderWidth: 1,
    borderColor: Colors.plum400,
    borderRadius: Spacing.cardRadius,
    padding: 10,
    width: "100%",
    opacity: 1,
  },
  checkedContainer: { opacity: 0.5 },
  left: {
    flex: 1,
    marginRight: 0,
  },
  checkbox: {
    width: 16,
    height: 16,
    borderColor: Colors.white,
    borderWidth: 1,
    borderRadius: 16 / 2,
    marginRight: 10,
    justifyContent: "center",
    alignItems: "center",
  },
  checkedCheckbox: {
    backgroundColor: Colors.teal700,
    borderWidth: 0,
  },
  text: { flex: 1 },
  entity: {
    marginBottom: 4,
  },
  icon: {
    marginRight: 5,
  },
  title: {
    textTransform: "capitalize",
  },
  centeredRow: {
    flexDirection: "row",
    alignItems: "center",
  },
});

export default Task;
